import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import Header from '../components/Header';
import { Helmet } from 'react-helmet-async';

function CareSuites() {
  useEffect(() => {
    const scriptSrc = 'https://player.vimeo.com/api/player.js';
    if (document.querySelector(`script[src="${scriptSrc}"]`)) return;

    const script = document.createElement('script');
    script.src = scriptSrc;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
    <Helmet>
        <title> Care Suites Rodwell | Large Nursing Rooms for Individuals</title>
        <meta
          name="description"
          content=" Discover our 27m² Care Suites, significantly larger than standard nursing rooms. Featuring private kitchenettes, they offer independence for couples & individuals."
        />
        <link rel="canonical" href="https://www.rodwell.house/care-suites" />
      </Helmet>

    <div className="page">
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <Header />

      <main id="main-content">
        <section className="content-section care-suites-page">
          <div className="care-suites-container">
            <h1>Care Suites</h1>
          </div>
        </section>

        <section className="content-section care-suites-video" aria-label="Care suite walk-through video">
          <div className="care-suites-video__container">
            <div className="care-suites-video__embed">
              <div className="care-suites-video__embed-inner">
                <iframe
                  src="https://player.vimeo.com/video/719773358?badge=0&autopause=0&player_id=0&app_id=58479"
                  title="Graham Care Care Suite Walk-Through"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                />
              </div>
            </div>
            <div className="care-suites-video__text">
              <h2>Not a typical nursing home bedroom</h2>
              <p>
                We build care suites that residents can call home. That means including lots of space to
                accommodate family and friends who visit, which traditional care homes typically lack.
              </p>
              <p>
                Each suite includes a dining space and kitchenette to help residents feel empowered to be
                independent in their own space — with the same 24-hour nursing care and support you would
                expect from a nursing home.
              </p>
              <p>Take a walk through a Graham Care care suite in the video.</p>
            </div>
          </div>
        </section>

        <section className="content-section care-suites-intro">
          <div className="section__container">
            <div className="section__text">
              <h2>Much more than nursing home bedrooms</h2>
              <p>We provide residents with much more space than traditional nursing home settings, but with the same level of nursing care and support.</p>
              <p>Our care suites differ from traditional nursing home bedrooms in three important ways:</p>
              <ol>
                <li>Social space with comfortable seats so that residents' families and friends can spend good quality time together in privacy and comfort.</li>
                <li>Dining space so that residents can enjoy their meals in their own room, if they wish.</li>
                <li>A kitchenette so that residents and their guests can prepare drinks and snacks.</li>
              </ol>
            </div>
            <div className="section__image">
              <img src="/whitstable-suite-image-3.jpg" alt="Care Suites at Rodwell House" />
            </div>
          </div>
        </section>

        <section className="content-section nursing-care-section">
          <div className="section__container">
            <div className="section__image">
              <img src="/whitstable-suite-image.jpg" alt="Nursing care at Rodwell House" />
            </div>
            <div className="section__text">
              <h2>Nursing care within your own home</h2>
              <p>Our homes are all registered to provide both personal and nursing care to the residents of the suites. The in-house team of registered nurses and carers is available 24 hours a day to respond to the residents' care needs when required. With Registered Nurses available on-site, the suites offer a permanent home where the residents do not need to worry about moving when their care needs increase.</p>
            </div>
          </div>
        </section>

        <section className="content-section relationships-section">
          <div className="section__container">
            <div className="section__text">
              <h2>Maintain relationships with family and friends</h2>
              <p>The move into a care setting often results in many key relationships being compromised. Our Care Suites are therefore particularly important as comfortable, spacious places to visit where residents' relationships with their families and friends can flourish.</p>
              <p>Residents' spouses can be accommodated in our studio care suites, so that couples can stay together even when one develops the need for on-going care.</p>
            </div>
            <div className="section__image">
              <img src="/whitstable-suite-main-room.jpg" alt="Care suite main room at Rodwell House" />
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <section className="footer__enquiry">
          <div className="footer__enquiry-container">
            <Link to="/contact-us" className="footer__enquiry-link">
              Enquire about Graham Care <span className="footer__arrow">▶</span>
            </Link>
          </div>
        </section>
        <div className="footer__container">
          <section className="contact-section">
            <div className="contact-section__content">
              <p>Graham Care Ltd, KT15 1HH</p>
              <p>Copyright © Graham Care Ltd</p>
            </div>
          </section>
        </div>
      </footer>
    </div>
    </>
  );
}

export default CareSuites;
